module.exports = __webpack_public_path__ + "img/lisence2.b5f8a3da.png";